/** @internal */
export function isObject(value: unknown): value is object {
  return value !== null && typeof value === 'object';
}

/** @internal */
export function isArray(value: unknown): value is unknown[] {
  return Array.isArray(value);
}

/** @internal */
export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

/** @internal */
export function isNumber(value: unknown): value is number {
  return typeof value === 'number';
}

/** @internal */
export function isBoolean(value: unknown): value is boolean {
  return typeof value === 'boolean';
}
